import { create } from 'zustand/react';
import { InvokeRpc } from '../../../util/hubs/types';

type AgentDrawerRpcServer = {};

type AgentDrawerHubStore = {
  isConnected: boolean;
  isUpdating: boolean;
  isRemoving: boolean;
  invoke: InvokeRpc<AgentDrawerRpcServer> | null;
  setInvoke: (cb: InvokeRpc<AgentDrawerRpcServer>) => void;
  setIsUpdating: (value: boolean) => void;
};

export const useAgentDrawerHubStore = create<AgentDrawerHubStore>((set) => ({
  isConnected: false,
  isUpdating: false,
  isRemoving: false,
  invoke: null,
  setInvoke: (invoke) => set({ invoke, isConnected: true }),
  setIsUpdating: (value: boolean) => set({ isUpdating: value })
}));
